(function() {
  'use strict';

  /* Build article photo gallery */
  var msnry, renderMasonryBlocks, startMasonry;

  renderMasonryBlocks = function() {
    var images, renderedHTML;
    images = $('#js-photo-gallery-content').find('a > img');
    renderedHTML = images.map(function(index, element) {
      var caption, image, link;
      link = $(element).parent();
      image = $(element);
      caption = (function() {
        if (image.attr('alt').length > 0) {
          return "<div class=\"PhotoGalleryItem-caption\">\n  " + (image.attr('alt')) + "\n</div>";
        } else {
          return "";
        }
      })();
      return "<div class=\"js-masonry-item PhotoGalleryItem\">\n  <a class=\"PhotoGalleryItem-link\" href=\"" + (link.attr('href')) + "\">\n    <img class=\"PhotoGalleryItem-image\" src=\"" + (image.attr('src')) + "\" alt=\"\" />\n    " + caption + "\n  </a>\n</div>";
    }).get().join(' ');
    return $('#js-photo-gallery-content').html(renderedHTML).append('<div class="js-masonry-guttersizer PhotoGallery-gutterSizer"></div>').show();
  };

  startMasonry = function() {
    var bottomMargin, initialImgLoad;
    bottomMargin = $('#js-photo-gallery-content .js-masonry-guttersizer').width();
    $('#js-photo-gallery-content .js-masonry-item').css('margin-bottom', bottomMargin + 'px');
    msnry.on('layoutComplete', function(msnryInstance, laidOutItems) {
      console.log("Masonry layout completed on " + laidOutItems.length + " items");
      return $('#js-photo-gallery-content').addClass('is-visible');
    });
    initialImgLoad = window.imagesLoaded($('#js-photo-gallery-content img'));
    return initialImgLoad.on('always', function() {
      return msnry.layout();
    });
  };


  /* Render Masonry blocks and init Masonry */

  if ($('#js-photo-gallery-content').length > 0) {
    renderMasonryBlocks();
    $('#js-photo-gallery-content .js-masonry-item a').magnificPopup({
      type: 'image',
      closeOnContentClick: true,
      closeBtnInside: true,
      fixedContentPos: true,
      mainClass: 'mfp-img-mobile mfp-with-zoom',
      image: {
        verticalFit: true
      },
      zoom: {
        enabled: true,
        duration: 300
      }
    });
    if (window.Modernizr.mq('only screen and (min-width: 641px)')) {
      msnry = new window.Masonry('#js-photo-gallery-content', {
        itemSelector: '.js-masonry-item',
        gutter: '.js-masonry-guttersizer',
        isResizeBound: true,
        isInitLayout: false
      });
      startMasonry();
    }
  }

}).call(this);
;

(function() {
  'use strict';

  /* Set first image from article body as article thumbnail */
  var setArticleThumb;

  setArticleThumb = function(index, element) {
    var allImages, articleBody, image;
    articleBody = $(element).attr('data-article-body');
    allImages = $.parseHTML(articleBody);
    image = $(allImages).find('a > img').first();
    $(element).find('a').html(image);
  };

  $('#js-blog-photo-gallery .js-item-image').each(setArticleThumb);

}).call(this);
;

(function() {
  'use strict';

  /* Show photo captions */
  $('#maincontent .pagecontent p img[alt]').each(function(index, element) {
    var image, parent;
    image = $(element);
    parent = image.parent();
    image.after(function() {
      var caption;
      caption = $(this).attr('alt');
      return $(document.createElement('div')).attr({
        'class': 'photo-caption'
      }).text(caption);
    });
    return parent.addClass('has-caption');
  });

}).call(this);
;

(function() {
  'use strict';

  /* Add class to image wrapper links */
  $('#maincontent .pagecontent a > img').each(function(index, element) {
    var image, link;
    image = $(element);
    link = image.parent();
    return link.addClass('image-link');
  });

}).call(this);
;

(function() {
  'use strict';

  /* Expandable sections on product page */
  var animateSections, createSectionTitle, sections;

  sections = $('#productinfo .js-exp-section');

  animateSections = function(evt) {
    var currentSection, header, otherHeaders, otherSections, tabName;
    header = $(evt.delegateTarget);
    tabName = header.attr('data-tab-name');
    currentSection = sections.filter("[data-tab-name='" + tabName + "']");
    otherSections = sections.not(currentSection);
    otherHeaders = $('#productinfo .js-exp-section-header').not(header);
    if (currentSection.hasClass('is-expanded')) {
      return;
    }
    otherHeaders.removeClass('is-expanded');
    header.addClass('is-expanded');
    otherSections.removeClass('is-expanded').velocity({
      p: 'slideUp',
      o: {
        duration: 300,
        easing: 'easeInOut'
      }
    });
    currentSection.addClass('is-expanded').velocity({
      p: 'slideDown',
      o: {
        duration: 300,
        easing: 'easeInOut'
      }
    });
  };

  createSectionTitle = function(index, element) {
    var heading, section, sectionHeader;
    section = $(element);
    heading = section.find('h1,h2,h3,h4,h5,h6').first();
    if (heading.length === 0) {
      return;
    }
    heading.css('display', 'none');
    sectionHeader = $(document.createElement('div')).attr({
      'class': 'js-exp-section-header ProductExpSection-header',
      'data-tab-name': section.attr('data-tab-name')
    }).prepend($(document.createElement('span')).attr({
      "class": 'ProductExpSection-title'
    }).text(heading.text())).prepend($(document.createElement('span')).attr({
      "class": 'js-exp-section-arrow ProductExpSection-arrow'
    }));
    section.wrap($(document.createElement('div')).attr({
      "class": 'ProductExpSection-wrapper'
    }));
    section.parent().prepend(sectionHeader);
  };

  if (sections.length === 0) {
    return;
  }

  sections.each(createSectionTitle);

  $('#productinfo .js-exp-section-header').click(animateSections);

  return;

}).call(this);
;

(function() {
  'use strict';

  /* Show Vimeo product videos in a lightbox */
  var setVideoThumb, videoLinks;

  videoLinks = $('.js-product-video');

  if (videoLinks.length === 0) {
    return;
  }

  setVideoThumb = function(index, element) {
    var videoLink, videoUrl, vimeoId;
    videoLink = $(element);
    videoUrl = new window.URI(videoLink.attr('href'));
    if (!_.includes(videoUrl.hostname(), 'vimeo')) {
      return;
    }
    vimeoId = _.last(videoUrl.segmentCoded());
    $.getJSON("https://vimeo.com/api/v2/video/" + vimeoId + ".json?callback=?").done(function(data) {
      var thumbnail;
      if (!_.isArray(data)) {
        return;
      }
      thumbnail = _.first(data).thumbnail_large;
      if (thumbnail == null) {
        return;
      }
      videoLink.css('background-image', "url('" + thumbnail + "')");
    }).fail(function() {
      return console.error('Request to Vimeo failed');
    });
  };

  videoLinks.each(setVideoThumb);

  videoLinks.magnificPopup({
    disableOn: 700,
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });

}).call(this);
;

(function() {
  'use strict';

  /* Hide AJAX cart buttons after clicking "Continue shopping" */
  $('#productinfo').on('click', '.js-close-ajax-notice', function(evt) {
    evt.preventDefault();
    $('#productinfo #detail .added').addClass('is-hidden').velocity({
      p: 'fadeOut',
      o: {
        duration: 200,
        easing: 'easeInOut'
      }
    });
  });

}).call(this);
;

(function() {
  'use strict';

  /* Newsletter Popup */
  var hidePopup, showPopup;

  showPopup = function(evt) {
    evt.preventDefault();
    $('.js-newsletter-popup').velocity({
      p: 'fadeIn',
      o: {
        duration: 300,
        easing: 'easeInOut',
        complete: function(elements) {
          return $(elements).removeClass('is-hidden');
        }
      }
    });
  };

  hidePopup = function(evt) {
    if (evt.target === evt.delegateTarget) {
      return $('.js-newsletter-popup').velocity({
        p: 'fadeOut',
        o: {
          duration: 300,
          easing: 'easeInOut',
          complete: function(elements) {
            return $(elements).addClass('is-hidden');
          }
        }
      });
    }
  };

  $('.js-newsletter-popup-trigger').click(showPopup);

  $('.js-newsletter-popup').click(hidePopup);

  $('.js-newsletter-popup-close').click(hidePopup);

}).call(this);
;

(function() {
  'use strict';

  /* Compile wholesale order and send it by email */
  var createProductList, form, moneyFormat, numeral, submitForm, updateValues;

  numeral = window.numeral;

  moneyFormat = '$0,0.00';

  form = $('#js-wholesale-order form');

  if (form.length === 0) {
    return;
  }

  updateValues = function(evt) {
    var orderTotal, originalQty, price, qty, qtyField, variantID;
    qtyField = $(evt.target);
    originalQty = _.round(qtyField.val(), 2) || 0;
    qty = _.round(qtyField.val()) || 0;
    price = qtyField.attr('data-line-price') || 0;
    variantID = qtyField.attr('data-variant-id');
    if (qty !== originalQty) {
      qtyField.val(qty);
    }
    form.find(".js-line-total[data-variant-id='" + variantID + "']").text(numeral(_.round(price / 100 * qty, 2)).format(moneyFormat));
    orderTotal = _.round(_.reduce(form.find('.js-qty').map(function(index, element) {
      return $(element).attr('data-line-price') / 100 * $(element).val();
    }).get(), function(total, value) {
      return total + value;
    }, 0), 2);
    form.find('.js-order-total').attr('data-order-total', orderTotal).text(numeral(orderTotal).format(moneyFormat));
    form.find('.js-order-total-field').remove();
    form.prepend($(document.createElement('input')).attr({
      'type': 'hidden',
      'name': 'order_total',
      'value': orderTotal,
      'class': 'js-order-total-field'
    }));
  };

  createProductList = function() {
    var orderTotal, productList, qtyFields;
    qtyFields = form.find('.js-qty').filter(function(index, element) {
      return $(element).val() * 1;
    });
    if (qtyFields.length === 0) {
      form.find('.js-error').text('No products selected');
      return false;
    }
    orderTotal = form.find('.js-order-total').first().attr('data-order-total') || 0;
    if ((orderTotal * 1) < 50) {
      form.find('.js-error').text('Sorry, there is a $50 per order minimum order. Please add to your order. Thanks.');
      return false;
    }
    productList = qtyFields.map(function(index, element) {
      var price;
      price = numeral($(element).attr('data-line-price') / 100).format(moneyFormat);
      return (index + 1) + ". " + ($(element).attr('data-line-title')) + " -- " + ($(element).val()) + " x " + price;
    }).get().join('\n');
    form.find('.js-product-list').remove();
    form.prepend($(document.createElement('input')).attr({
      'type': 'hidden',
      'name': 'order_details',
      'value': '\n' + productList,
      'class': 'js-product-list'
    }));
    form.find('.js-error').empty();
    return true;
  };

  submitForm = function(formElement) {
    var email, productListCreated, requestData;
    productListCreated = createProductList();
    if (!productListCreated) {
      console.log('Product list not created');
      return;
    }
    requestData = _.reduce($(formElement).serializeArray(), function(data, field) {
      data[field.name] = field.value;
      return data;
    }, {});
    email = _.get(window, 'reluctant.shop.email', '');
    if (!email) {
      console.log('Shop email is not defined');
      return;
    }
    $.ajax({
      url: "//formspree.io/" + email,
      method: "POST",
      data: requestData,
      dataType: "json"
    }).done(function(data) {
      console.log(data);
      form.find('.js-success').addClass('is-visible');
      return form.find("input[type='submit']").attr('disabled', 'disabled');
    }).error(function(data, textStatus) {
      console.log(data);
      console.log(textStatus);
      return form.find('.js-error').text(textStatus);
    });
  };

  form.validate({
    debug: true,
    ignore: '.js-qty',
    submitHandler: submitForm,
    invalidHandler: function() {
      form.find('.js-error').text('Form is incomplete. Please check email and name fields');
    },
    highlight: function() {}
  });

  form.on('input', '.js-qty', updateValues);

}).call(this);
;

(function() {
  'use strict';

  /* Persist cart note */
  var cartNoteField, cartNoteUpdates, getFieldValue, initialCartNote, noteContainer, noteLabel;

  cartNoteField = $('.js-cart-note');

  if (cartNoteField.length === 0) {
    return;
  }

  getFieldValue = function(field) {
    return field.val();
  };

  initialCartNote = (function() {
    var cookieContent;
    cookieContent = $.cookie('reluctant-cart-note') || '';
    if (cookieContent) {
      return _.trim(cookieContent);
    }
    return _.trim(_.get(window, 'reluctant.cart_note', ''));
  })();

  cartNoteField.val(initialCartNote);

  cartNoteUpdates = cartNoteField.asEventStream('keyup').debounce(200).map(getFieldValue, cartNoteField).toProperty(initialCartNote);

  cartNoteUpdates.onValue(function(value) {
    $.cookie('reluctant-cart-note', value);
  });


  /* Show/hide cart note */

  noteContainer = $('.js-cart-note-container');

  noteLabel = $('label[for="note"]');

  noteLabel.asEventStream('click').map(function() {
    return noteContainer.hasClass('is-expanded');
  }).onValue(function(expanded) {
    if (expanded) {
      noteContainer.removeClass('is-expanded');
      return;
    }
    noteContainer.addClass('is-expanded');
  });

  if (initialCartNote) {
    noteLabel.click();
  }

}).call(this);
;

(function() {
  'use strict';

  /* eslint-disable no-unused-vars */

  /*
   * Make quick order drawer sticky
   */
  var drawer, links, menu, ref, ref1, sections, selectFieldText, setActiveLink, stickyDrawer, stickyMenu;

  if (((ref = window.Waypoint) != null ? ref.Sticky : void 0) == null) {
    return;
  }

  drawer = $('#js-quick-order-drawer');

  if (drawer.length === 0) {
    return;
  }

  stickyDrawer = new window.Waypoint.Sticky({
    element: drawer.first(),
    stuckClass: 'is-stuck',
    wrapper: false,
    offset: '32px',
    handler: function() {
      return $(document).trigger('reluctant:quick_order_drawer_change');
    }
  });


  /* Resize quick order drawer to fit screen height */

  $(window).asEventStream('resize', function(evt) {
    return 1;
  }).merge($(document).asEventStream('reluctant:quick_order_drawer_change', function(evt) {
    return 1;
  })).debounce(300).onValue(function(value) {
    var targetHeight;
    targetHeight = window.verge.viewportH() - 16 * 4;
    return $('#js-quick-order-drawer-placeholder').css('height', targetHeight + 'px');
  });


  /*
   * Make quick order menu sticky
   */

  menu = $('#js-quick-order-menu');

  if (menu.length === 0) {
    return;
  }

  stickyMenu = new window.Waypoint.Sticky({
    element: menu.first(),
    stuckClass: 'is-stuck',
    wrapper: '<div class="QuickOrderMenu-stickyPlaceholder" />',
    offset: '32px'
  });

  if (((ref1 = window.Waypoint) != null ? ref1.Inview : void 0) == null) {
    return;
  }

  sections = $('.js-quick-order-section-target');

  links = menu.find('.js-quick-order-menu-link');

  setActiveLink = function(hash) {
    var goal;
    goal = hash || window.location.hash;
    links.removeClass('is-active');
    return links.filter("[href='" + ('#' + goal.replace('#', '')) + "']").addClass('is-active');
  };

  sections.each(function(index, element) {
    var section, stickyLink;
    section = $(element);
    return stickyLink = new window.Waypoint.Inview({
      element: section,
      entered: function() {
        return setActiveLink(section.attr('id'));
      }
    });
  });

  $(window).on('hashchange', function(evt) {
    return setActiveLink();
  });

  setActiveLink();


  /*
   * Select all text in qty field on focus
   */

  selectFieldText = function(evt) {
    $(evt.target).select().one('mouseup', function(singleEvt) {
      return singleEvt.preventDefault();
    });
  };

  $('.js-quick-order-product').on('focus', 'input[name="quantity"]', selectFieldText);

  return;

}).call(this);
;

(function() {
  'use strict';

  /* Show back to quick order button */
  var referrer;

  referrer = document.referrer || '';

  if (referrer.indexOf('quick-order') < 0) {
    return;
  }

  $('.js-product-back-to-quick-order').addClass('is-visible');

  return;

}).call(this);
